import { render, staticRenderFns } from "./BoardMemberIndex.vue?vue&type=template&id=619c5b61&scoped=true&"
import script from "./BoardMemberIndex.vue?vue&type=script&lang=js&"
export * from "./BoardMemberIndex.vue?vue&type=script&lang=js&"
import style0 from "./BoardMemberIndex.vue?vue&type=style&index=0&id=619c5b61&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "619c5b61",
  null
  
)

export default component.exports